import State from 'store/State';
import { selectOpenSubmissionsState } from '../selectors';
import { useSelector } from 'react-redux';
import {
    OpenSubmissionsStreamState,
    OpenSubmissionsDataState,
} from './OpenSubmissionsStreamDataState';

export const selectStreamState: (
    state: State,
    widgetKey: string
) => OpenSubmissionsStreamState | undefined = (state, widgetKey) => {
    const widgetState = selectOpenSubmissionsState(state, widgetKey);
    return widgetState?.stream;
};

export const selectStreamKey: (
    state: State,
    widgetKey: string
) => string | undefined = (state, widgetKey) => {
    const streamState = selectStreamState(state, widgetKey);
    return streamState?.streamKey;
};

export const selectStreamData: (
    state: State,
    widgetKey: string
) => OpenSubmissionsDataState | undefined = (state, widgetKey) => {
    const streamState = selectStreamState(state, widgetKey);
    return streamState?.data;
};

export const useSelectOpenSubmissionsStreamData = (widgetKey: string) =>
    useSelector((state: State) => selectStreamData(state, widgetKey));
